<template>
  <section class="policy-form">
    <housemaid-policy-form
      v-if="productId == 12"
      ref="housemaid-policy-form"
      :form="formData"
      :isCancel="isCancel"
      :action="action"
      :check-refer="2"
      :isEndorsement="isEndorsement"
      @getFormData="getFormData" />
    <working-policy-form
      v-else-if="productId == 13"
      ref="working-policy-form"
      :form="formData"
      :isCancel="isCancel"
      :check-refer="2"
      :isEndorsement="isEndorsement"
      @getFormData="getFormData" />
    <decoration-policy-form
      v-else-if="productId == 15"
      ref="decoration-policy-form"
      :form="formData"
      :isCancel="isCancel"
      :check-refer="2"
      :isEndorsement="isEndorsement"
      :isAdjust="isAdjust"
      @getFormData="getFormData" />

    <travel-policy-form
      v-else-if="productId == 14"
      ref="travel-policy-form"
      :form="formData"
      :isCancel="isCancel"
      :check-refer="2"
      :isAdjust="isAdjust"
      :isEndorsement="isEndorsement"
      @getFormData="getFormData" />

    <student-policy-form
      v-else-if="productId == 16"
      ref="student-policy-form"
      :form="formData"
      :isCancel="isCancel"
      :check-refer="2"
      :is-benefit-coverage="isAdjust"
      :isEndorsement="isEndorsement"
      @getFormData="getFormData" >
    </student-policy-form>

    <homefire-policy-form
      v-else-if="productId == 17"
      ref="homefire-policy-form"
      :form="formData"
      :isCancel="isCancel"
      :check-refer="2"
      :isEndorsement="isEndorsement"
      :is-benefit-coverage="isAdjust"
      @getFormData="getFormData" >
    </homefire-policy-form>
    <personal-policy-form
      v-else-if="productId == 18"
      ref="personal-policy-form"
      :form="formData"
      :isCancel="isCancel"
      :check-refer="2"
      :isEndorsement="isEndorsement"
      @getFormData="getFormData" >
    </personal-policy-form>
    <fire-policy-form
      v-else-if="productId == 20"
      ref="fire-policy-form"
      :form="formData"
      :isCancel="isCancel"
      :check-refer="2"
      :isEndorsement="isEndorsement"
      @getFormData="getFormData" >

    </fire-policy-form>
    <pet-policy-form
      v-else-if="productId == 22"
      ref="pet-policy-form"
      :form="formData"
      :isCancel="isCancel"
      :check-refer="2"
      :isEndorsement="isEndorsement"
      @getFormData="getFormData"/>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import HousemaidPolicyForm from '@/views/quoting/modules/housemaid/form/housemaid-policy-form'
import DecorationPolicyForm from '@/views/quoting/modules/decoration/form/decoration-policy-form'
import HomefirePolicyForm from '@/views/quoting/modules/homefire/form/homefire-policy-form'
import TravelPolicyForm from '@/views/quoting/modules/travel/form/travel-policy-form'
import StudentPolicyForm from '@/views/quoting/modules/student/form/student-policy-form'
import WorkingPolicyForm from '@/views/quoting/modules/working/form/working-policy-form'
import personalPolicyForm from '@/views/quoting/modules/personal/form/personal-policy-form'
import firePolicyForm from '@/views/quoting/modules/homefire/form/fire-policy-form'
import petPolicyForm from '@/views/quoting/modules/pet/form/pet-policy-form'

export default {
  name: 'EndorseHousemaidPolicyForm',
  components: {
    HousemaidPolicyForm,
    DecorationPolicyForm,
    HomefirePolicyForm,
    TravelPolicyForm,
    StudentPolicyForm,
    WorkingPolicyForm,
    firePolicyForm,
    personalPolicyForm,
    petPolicyForm
  },
  mixins: [MixinOptions, MixinRules],
  props: {
    action:{
      type: [String, Number],
      default: 0 //0正常 1 - endorse, 2 - cancel
    },
    form: {
      type: Object,
      default: () => ({})
    },
    disabledList: {
      type: Array,
      default: () => ([])
    },
    isCancel: {
      type: Boolean,
      default: false
    },
    isAdjust: {
      type: Boolean,
      default: false
    },
    isEndorsement: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      formDataLock: 0, // 表單鎖，防止外層修改數據覆蓋了組件裏的表單數據
      formData: {
        // date: [],
        pcy_cmnt_dt: ''
      },
      resultForm: {
        pcy_cmnt_dt: ''
      },
    }
  },
  computed: {
    orderId() {
      return this.form.id
    },
    productId(){
      return this.form.product_id
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        let params = Object.assign(this.formData, val)
        this.formDataLock += 1
        this.formData = JSON.parse(JSON.stringify(params))
        this.resultForm = JSON.parse(JSON.stringify(params))
      }
    }
  },
  methods: {
    //todo
    async submitForm() {
      // if(this.isCancel) {
      //   // 校驗 pcy_cmnt_dt
      //   console.log('resultForm')
      //   console.log('this.resultForm ',this.resultForm )
      //   this.$emit('submit', this.resultForm)
      //   return
      // }
      const productForm = {
        12: 'housemaid-policy-form',
        13: 'working-policy-form',
        14: 'travel-policy-form',
        15: 'decoration-policy-form',
        17: 'homefire-policy-form',
        18: 'personal-policy-form',
        20: 'fire-policy-form',
        16: 'student-policy-form',
        22: 'pet-policy-form',
      }

      this.$refs[productForm[this.productId]].submitForm()

      // // 表單校驗
      // if(!this.handler().validateForm()) {
      //   return
      // }
      // // 獲取文件數據
      // const documentParams = await this.$refs['document-form'].submitForm()
      // if(!documentParams) return
      //
      // this.resultForm = Object.assign(this.resultForm, documentParams)

      // this.$refs.form.validate(valid => {
      //   if(valid) {
      //     // this.resultForm = {
      //     //   ...this.resultForm,
      //     // pcy_cmnt_dt: this.formData.pcy_cmnt_dt
      //     // period_start: this.formData.date[0],
      //     // period_end: this.formData.date[1]
      //     // }
      //     // 判斷是否要同步投保人資料
      //     if(this.resultForm.isUpdatePolicyData === 1) {
      //       this.$refs['policy-holder'].openConfirmDialog()
      //     }
      //     else {
      //       this.$emit('submit', this.resultForm)
      //     }
      //   }
      // })

    },
    getFormData(data) {
      this.resultForm = Object.assign(this.resultForm, data)
      this.$emit('submit', this.resultForm)
    },
    getSubFormData(form, data) {
      this.subForm[form] = true

      this.resultForm = Object.assign(this.resultForm, data)
    }
  }
}
</script>
